export default "__VITE_ASSET__CpGSQZRX__"